export default "__VITE_ASSET__40407689__"